import igniteToHubspotProductsMap from "./igniteToHubspotProductsMap";
import fields from './igniteToHubspotFieldNames.mjs';

const buildHubspotFormBody = ({businessName, firstName, lastName, email, phone, answers, cartProducts, recommendedProducts, user, guideId}) => {
  console.log('postToHubspot | Preparing request body');
  const date = new Date();
  return {
    "submittedAt": date.getTime(),
    "fields": [
      ...getUserFields({businessName, firstName, lastName, email, phone, user, guideId}),
      ...getAnswerFields({answers}),
      ...getProductFields({recommendedProducts, cartProducts})
    ]
  };
};

const getUserFields = ({businessName, firstName, lastName, email, phone, user, guideId}) => {
  const businessNameField = businessName ? [ {
    name: fields.businessName,
    value: businessName
  }] : [];

  return [
    ...businessNameField,
    {
      name: fields.firstName,
      value: firstName
    },
    {
      name: fields.lastName,
      value: lastName
    },
    {
      name: fields.email,
      value: email
    },
    {
      name: fields.phone,
      value: phone
    },
    {
      name: fields.userId,
      value: user.uuid
    },
    {
      name: fields.guideId,
      value: guideId
    },
    {
      name: fields.igniteEmail,
      value: true
    },
    {
      name: fields.igniteFirstName,
      value: firstName
    },
    {
      name: fields.igniteLastName,
      value: lastName
    }
  ]
};

const getAnswerFields = ({answers}) => {
  return [
    {
      name: fields.postalCode,
      value: answers.hasOwnProperty('postalCode') ? answers.postalCode.value[0] : ""
    }
  ]
}
const getProductFields = ({recommendedProducts, cartProducts}) => {
  const recommendedProductIds = recommendedProducts.map(p => p.id.toString());
  const cartProductIds = cartProducts.map(p => p.id.toString());
  return Object.keys(igniteToHubspotProductsMap).map(productId => {
    const field = igniteToHubspotProductsMap[productId];
    field.name = field.name.toLowerCase();
    if(recommendedProductIds.includes(productId)){
      field.value = "Y" //previously used to sent Y only for products in cart, and R for other recommendations. Changed per HWB-411
    }else{
      field.value = "-"
    }
    return field;
  }).filter(f => f.value);
};

export default buildHubspotFormBody;
